export const mapShortProfessorToProfessor = language => ({
  id,
  name,
  image,
  description,
  organisation,
  organisationUrl,
  jobTitle
}) => {
  return {
    contentId: id,
    descriptions: {
      [language]: description
    },
    id,
    image: image || '',
    name,
    organisation: organisation || undefined,
    organisationUrl: organisationUrl || undefined,
    jobTitle: jobTitle || undefined
  };
};